import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider, createStandaloneToast } from '@chakra-ui/react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import customTheme from './stylesheets/theme';
import Home from './pages/home';
import Tours from './pages/tours';
import DestinationsPage from './pages/destinations';
import AboutPage from './pages/about';
import BookPage from './pages/book';
import VirtualToursPage from './pages/virtualTours';
import PrivacyPage from './pages/privacy';
import TermsPage from './pages/terms';
import ContactPage from './pages/contact';

const root = ReactDOM.createRoot(document.getElementById('root'));
const { ToastContainer } = createStandaloneToast();

root.render(
    <ChakraProvider theme={customTheme}>
        <ToastContainer />
        <Router>
            <Routes>
                <Route path='/health/ok' element={<div>ok</div>} />
                <Route path='' element={<Home />} />
                <Route path='/tours' element={<Tours />} />
                <Route path='/destinations' element={<DestinationsPage />} />
                <Route path='/about' element={<AboutPage />} />
                <Route path='/book' element={<BookPage />} />
                <Route path='/virtual-tours' element={<VirtualToursPage />} />
                <Route path='/privacy' element={<PrivacyPage />} />
                <Route path='/terms' element={<TermsPage />} />
                <Route path='/contact' element={<ContactPage />} />
                <Route path='/*' element={<Home />} />
            </Routes>
        </Router>
    </ChakraProvider>
);
